import { type TabItem, Tabs, Typography } from "@kyan/ui";

const buySellTabItems: TabItem[] = [
  {
    id: "buy",
    label: <Typography size={12}>BUY</Typography>,
    variant: "buy",
  },
  {
    id: "sell",
    label: <Typography size={12}>SELL</Typography>,
    variant: "sell",
  },
];

export interface BuySellSwitchProps {
  isBuy: boolean;
  onChange?: (id: string) => void;
}

export const BuySellSwitch: React.FC<BuySellSwitchProps> = ({
  isBuy,
  onChange,
}) => {
  return (
    <Tabs
      className="w-full"
      items={buySellTabItems}
      itemClassName="h-10 sm:h-8"
      value={isBuy ? "buy" : "sell"}
      onChange={onChange}
    />
  );
};
